module Meevo.Plugins.Egifts {
    'use strict';

    import EGiftTemplateCatEnum = Meevo.Model.EGiftTemplateCatEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;


    export class TemplatesSection extends EgiftsBaseTemplate {
        public selectedCategoryForAddingNewTemplate: number;

        public request: EgiftTemplates.ITemplateSectionReq = this.defaultRequest
        public newTemplate: any = this.emptyNewTemplateModel;
        public eGiftTemplateTypeEnum: EGiftTemplateType;
        public categoryTypes: Array<ICategoryTypesOption> = this.categoryTypesData;


        constructor(params: ISectionParamsEgifts,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $q: angular.IQService,
            protected securityChecker: Meevo.Components.Common.ISecurityService) {

            super(params, modalService, $q);           
        }

        selectType() {
            if (this.securityChecker.hasSecurityDenyOrGrant(
                Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_TEMPLATES_SYSTEM +
                Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {

                this.changeTempalatesType(Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_TEMPLATES_SYSTEM,
                    EGiftTemplateType.SystemTemplate);

            } else {
                this.changeTempalatesType(Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_TEMPLATES_CUSTOM,
                    EGiftTemplateType.CustomTemplate);
            }
        }

        createTemplate(categoryId: EGiftTemplateCatEnum): any {
            return this.egiftsService.createTemplate(this.getNewTemplate(categoryId), false).then(template => {
                this.selectedCategoryForAddingNewTemplate = 0;
                this.getData(true);
                this.newTemplate = this.emptyNewTemplateModel;
            }).finally(() => {
                this.templateEditStatus = TemplateEditStatus.None;
                this.context.setMode(MaintenanceFormState.Readonly);
            });
        }

        changeSelectedCategoryForAddingNewTemplate(value?: number): void {
            this.templateEditStatus = TemplateEditStatus.IsEditingNew;
            this.context.edit();
            this.selectedCategoryForAddingNewTemplate = value || 0;
            this.newTemplate = this.emptyNewTemplateModel;
            this.newTemplate.eGiftTemplateCatEnum = this.selectedCategoryForAddingNewTemplate;
        }

        public addTemplateToDesiredCategory(template: ITemplateItem): void {
            if (_.isUndefined(this.templatesList[template.eGiftTemplateCatEnum])) {
                this.templatesList[template.eGiftTemplateCatEnum] = [];
            }
            this.templatesList[template.eGiftTemplateCatEnum].push(template);
        }

        private resetValues(): void {
            this.templatesList = {};
            this.selectedCategoryForAddingNewTemplate = 0;
            this.newTemplate = this.emptyNewTemplateModel;
        }

        customSave() {
            switch (this.templateEditStatus) {
                case TemplateEditStatus.IsEditingNew: return this.createTemplate(this.newTemplate.eGiftTemplateCatEnum);
                case TemplateEditStatus.IsEditingExisting: return this.saveEditedTemplate(this.newTemplate);
            }
        }

        getAddSecurityKey(baseKey): string {

            return baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
        }

        changeTempalatesType(baseKey, eGiftTemplateType: EGiftTemplateType) {
            this.eGiftTemplateTypeEnum = eGiftTemplateType;
            this.context.buildCrudSecurityKeysBase(baseKey, true);
        }

        get eGiftTemplateType() {
            return EGiftTemplateType;
        }  

        ////Template Data////

        get defaultRequest(): EgiftTemplates.ITemplateSectionReq {
            return {
                criteria: {
                    objectState: null,
                    templateName: null,
                    templateSupportsLogo: null,
                    eGiftTemplateCategoryEnum: null,
                    //eGiftTemplateTypeEnum: EGiftTemplateType.CustomTemplate,
                    isGiftCard: false,
                    isEGift: null,
                    businessTypeId: null,
                    priceGroupId: null,
                    filter: null,
                    maintenanceMode: true,
                    isGlobal: true
                },
                asLocationId: 0,
                itemsPerPage: 1000
            }
        }

        get categoryTypesData(): Array<ICategoryTypesOption> {
           return [
                { value: null, label: 'LABEL_ALL' },
                //{ value: EGiftTemplateCatEnum.AllOccasion, label: 'LABEL_EGIFT_ALL_OCCASION' },
                { value: EGiftTemplateCatEnum.Anniversary, label: 'LABEL_EGIFT_ANNIVERSARY' },
                { value: EGiftTemplateCatEnum.AnyOccasion, label: 'LABEL_EGIFT_ANY_OCCASION' },
                { value: EGiftTemplateCatEnum.BabyShower, label: 'LABEL_EGIFT_BABY_SHOWER' },
                { value: EGiftTemplateCatEnum.Birthday, label: 'LABEL_EGIFT_BIRTHDAY' },
                { value: EGiftTemplateCatEnum.Congratulations, label: 'LABEL_EGIFT_CONGRATULATIONS' },
                { value: EGiftTemplateCatEnum.FathersDay, label: 'LABEL_EGIFT_FATHERS_DAY' },
                { value: EGiftTemplateCatEnum.Holiday, label: 'LABEL_EGIFT_HOLIDAY' },
                { value: EGiftTemplateCatEnum.MothersDay, label: 'LABEL_EGIFT_MOTHERS_DAY' },
                { value: EGiftTemplateCatEnum.ThankYou, label: 'LABEL_EGIFT_THANK_YOU' },
                { value: EGiftTemplateCatEnum.Valentine, label: 'LABEL_EGIFT_VALENTINE' },
                { value: EGiftTemplateCatEnum.Wedding, label: 'LABEL_EGIFT_WEDDING' },
            ];
        }

        get emptyNewTemplateModel(): EgiftTemplates.INewTemplate {
            return {
                eGiftTemplateCatEnum: null,
                //eGiftTemplateTypeEnum: null,
                id: null,
                objectStateEnum: ObjectStateEnum.Inactive,
                templateName: null,
                templateSupportsLogo: false,
                isGiftCard: false
            };
        }


    }
}